import React, {Component} from 'react';
import FeedingGuidelinesHeader from './../FeedingGuidelinesHeader';
import FeedingGuidelinesIntro from './../FeedingGuidelinesIntro';
import FeedingGuidelinesProducts from './../FeedingGuidelinesProducts';
import FeedingGuidelinesBodyCondition from './../FeedingGuidelinesBodyCondition';
import FeedingGuidelinesNotes from './../FeedingGuidelinesNotes';
import FeedingGuidelinesFoodIntake from './../FeedingGuidelinesFoodIntake';
import FeedingGuidelinesPersonalizedNutrientProfile from './../FeedingGuidelinesPersonalizedNutrientProfile';
import FeedingGuidelinesDisclaimer from './../FeedingGuidelinesDisclaimer';

class Maintenance extends Component {

  render(){
    const {output} = this.props;

    return (
      <div>
        <FeedingGuidelinesHeader output={output} />
        <FeedingGuidelinesIntro output={output} />
        <div className="row nutri-body">
          <div className="col-md-6">
            <FeedingGuidelinesProducts output={output} />
          </div>
          <div className="col-md-6"><FeedingGuidelinesBodyCondition output={output} /></div>
        </div>
        <FeedingGuidelinesNotes output={output} />
        <FeedingGuidelinesDisclaimer output={output} />
      </div>
    )
  }

}

export default (Maintenance);
